import { batteryContractBundle } from "./battery-contract-bundle"
import { ContractDrawer } from "../../ProposalSetup/contract/ContractDrawer"

export {
  NOT_READY_HEADLINE,
  READY_HEADLINE,
  RECONCILING_HEADLINE,
  SUPPORT_BLOCKER_MESSAGE,
  VIEW_ONLY_NOTE,
} from "../../ProposalSetup/contract/ContractDrawer"

/**
 * Routed sibling of the Setup drawers at /battery-proposal/:proposalId/contract.
 * The shared Contract drawer over Battery's readiness, send and fixes; a
 * Concert plan shows its application status instead.
 */
export const BatteryContractDrawer = (): JSX.Element | null => (
  <ContractDrawer bundle={batteryContractBundle} />
)
